import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import MainToolbar from '../MainToolbar';
import { t } from '../common/LocalizationProvider';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import SettingsDrawer from "../shared/SettingsDrawer";

import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  makeStyles,
  IconButton,
  CssBaseline,
  useTheme,
  useMediaQuery,
  Container
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {cyberStyles} from "../cssShared/cyberTheme";

const useTableStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));

const usePageStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
}));


const ComputedAttributeView = ({ updateTimestamp, onMenuClick }) => {
  const classes = useTableStyles();
  const [items, setItems] = useState([]);

  const subadminEnabled = useSelector(state => state.session.user && state.session.user.subadmin)

  useEffectAsync(async () => {
    const response = await fetch('/api/attributes/computed');
    if (response.ok) {
      setItems(await response.json());
    }
  }, [updateTimestamp]);

  return (
      <TableContainer className={classes.container}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {subadminEnabled && <TableCell className={classes.headerCell + ' ' + classes.columnAction} />}
              <TableCell className={classes.headerCell}>{t('sharedDescription')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedAttribute')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedExpression')}</TableCell>
              <TableCell className={classes.headerCell}>{t('sharedType')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
                <TableRow key={item.id} className={classes.row}>
                  {subadminEnabled &&
                      <TableCell className={classes.columnAction} padding="none">
                        <IconButton onClick={(event) => onMenuClick(event.currentTarget, item.id)}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                  }
                  <TableCell style={{ fontWeight: 500 }}>{item.description}</TableCell>
                  <TableCell style={{ color: '#00f2ff', fontFamily: 'monospace' }}>{item.attribute}</TableCell>
                  <TableCell style={{ opacity: 0.85, fontFamily: 'monospace' }}>{item.expression}</TableCell>
                  <TableCell>{item.type}</TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
  );
}

const ComputedAttributesPage = () => {
  const classes = usePageStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [hideDrawer, setHideDrawer] = useState(() => localStorage.getItem('hideDrawer') === 'true');

  return (
      <div className={classes.settingRoot}>
        <CssBaseline />

        {!isMobile && <div className={classes.appBarWrapper}>
          <MainToolbar/>
        </div>}

        <SettingsDrawer
            hideDrawer={hideDrawer}
            setHideDrawer={setHideDrawer}
            page={'settings'}
        />

        <main className={classes.content}>
          <div className={classes.toolbarSpacer} />

          <Container maxWidth="xl">
            <EditCollectionView
                content={ComputedAttributeView}
                editPath="/settings/attribute"
                endpoint="attributes/computed"
            />
          </Container>
        </main>
      </div>
  );
}

export default ComputedAttributesPage;